import React, { Component } from "react";
import { useParams, useNavigate } from "react-router-dom";
function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} params={params} />;
  }
  return ComponentWithRouter;
}

export default withRouter;
